import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default values => ({
  amount: values.amount || '',
  paymentDate: momentLocalTimezone(),
  paymentForm: values.paymentForm || '',
  isPayoffRequest: values.isPayoffRequest || false
});
